module.exports = flarum.extensions['fof-user-directory'];